module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABOSURBVHgB7dYhEoBADATBHK/ME/NL8AhwbFHXbRMzbqsA2Nl6e5iZ8+ne3evL/7ujfk5AmoA0AUCWLZQmIE1AmgAgyxZKE5AmIE0AACRds0YkLk3OmGQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/app@2x.png
// module id = 733
// module chunks = 0